import {
    impressionsId,
    smvId,
    durationId,
    exposuresId,
} from '../constants/pacingMetrics';
import * as format from './formatters';

const getGoalDescription = ({
    goal: { metricId, targetValue },
    currency = null,
}) => {
    if (!targetValue || !metricId) return null;
    const formattedValue = format.decimal(targetValue);
    let label = null;
    let value = null;
    switch (metricId) {
        case impressionsId:
            label = parseInt(targetValue) > 1 ? `impressions` : `impression`;
            value = formattedValue;
            break;

        case exposuresId:
            label = parseInt(targetValue) > 1 ? `exposures` : `exposure`;
            value = formattedValue;
            break;

        case smvId:
            label = `SMV`;
            value = format.currency(targetValue, { currency });
            break;

        case durationId:
            label =
                parseInt(targetValue) > 1
                    ? `seconds (duration)`
                    : `second (duration)`;
            value = formattedValue;
            break;

        default:
            break;
    }
    return {
        label,
        value,
    };
};

export default getGoalDescription;
